import { c as _c } from "react-compiler-runtime";
import clsx from "clsx";
import React from "react";
import { ProgressBar as AriaProgressbar } from "react-aria-components";
import { icon } from "../icon.css.js";
import { AlertCircle } from "../icons/line.js";
import { base, fadeOutAnimationStyle, spinner, tick } from "./Spinner.css.js";
import useI18n from "./internal/useI18n.js";
import { useSuccessSpinnerState } from "./internal/useSuccessSpinnerState.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PlainSpinner = t0 => {
  const $ = _c(9);
  const {
    color,
    startAnimation
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = spinner({
      color
    });
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = startAnimation && fadeOutAnimationStyle;
  let t3;
  if ($[2] !== t2) {
    t3 = clsx(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = /*#__PURE__*/_jsx("path", {
      className: t3,
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.57538 4.57538C5.74706 3.4037 7.17941 2.52595 8.75532 2.01391c1.57588-.51205 3.25068-.64385 4.88728-.38464 1.6366.25922 3.1886.90209 4.5291 1.87605 1.3406.97397 2.4316 2.25138 3.1839 3.72778C22.1078 8.70951 22.5 10.343 22.5 12c0 1.657-.3922 3.2905-1.1444 4.7669-.7523 1.4764-1.8433 2.7538-3.1839 3.7278-1.3405.9739-2.8925 1.6168-4.5291 1.876"
    });
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t4) {
    t5 = /*#__PURE__*/_jsx("svg", {
      fill: "none",
      viewBox: "0 0 24 24",
      className: t1,
      children: t4
    });
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
const SuccessCheck = t0 => {
  const $ = _c(5);
  const {
    startAnimation
  } = t0;
  let t1;
  if ($[0] !== startAnimation) {
    t1 = tick({
      startAnimation
    });
    $[0] = startAnimation;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx("path", {
      d: "M13.3332 4L5.99984 11.3333L2.6665 8",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = /*#__PURE__*/_jsx("svg", {
      fill: "none",
      viewBox: "0 0 16 16",
      className: t1,
      children: t2
    });
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
const BaseSpinner = (t0, ref) => {
  const $ = _c(40);
  let propRenderState;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      state: t1,
      size: t2,
      color: t3,
      renderState: propRenderState,
      startAnimation: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = propRenderState;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    propRenderState = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  const state = t1 === undefined ? "loading" : t1;
  const size = t2 === undefined ? "m" : t2;
  const color = t3 === undefined ? "royalBlue" : t3;
  const propStartAnimation = t4 === undefined ? false : t4;
  const i18n = useI18n();
  let t5;
  if ($[7] !== i18n || $[8] !== props) {
    t5 = props["aria-labelledby"] == null && props["aria-label"] == null ? i18n.format("loading") : props["aria-label"];
    $[7] = i18n;
    $[8] = props;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const ariaLabel = t5;
  const {
    renderState: internalRenderState,
    startAnimation: internalStartAnimation
  } = useSuccessSpinnerState(state);
  const renderState = propRenderState ?? internalRenderState;
  const startAnimation = propRenderState == null ? internalStartAnimation : propStartAnimation;
  if (renderState === "error") {
    let t6;
    if ($[10] !== size) {
      t6 = base({
        size,
        error: true
      });
      $[10] = size;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== size || $[13] !== startAnimation) {
      t7 = clsx(icon({
        size
      }), startAnimation && fadeOutAnimationStyle);
      $[12] = size;
      $[13] = startAnimation;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t7) {
      t8 = /*#__PURE__*/_jsx(AlertCircle, {
        className: t7
      });
      $[15] = t7;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== startAnimation) {
      t9 = /*#__PURE__*/_jsx(SuccessCheck, {
        startAnimation: startAnimation
      });
      $[17] = startAnimation;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== ariaLabel || $[20] !== props || $[21] !== ref || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
      t10 = /*#__PURE__*/_jsxs(AriaProgressbar, {
        "aria-label": ariaLabel,
        className: t6,
        isIndeterminate: true,
        ref: ref,
        ...props,
        children: [t8, t9]
      });
      $[19] = ariaLabel;
      $[20] = props;
      $[21] = ref;
      $[22] = t6;
      $[23] = t8;
      $[24] = t9;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    return t10;
  }
  if (renderState === "success") {
    return null;
  }
  let t6;
  if ($[26] !== size) {
    t6 = base({
      size
    });
    $[26] = size;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== color || $[29] !== startAnimation) {
    t7 = /*#__PURE__*/_jsx(PlainSpinner, {
      startAnimation: startAnimation,
      color: color
    });
    $[28] = color;
    $[29] = startAnimation;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== startAnimation) {
    t8 = /*#__PURE__*/_jsx(SuccessCheck, {
      startAnimation: startAnimation
    });
    $[31] = startAnimation;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== ariaLabel || $[34] !== props || $[35] !== ref || $[36] !== t6 || $[37] !== t7 || $[38] !== t8) {
    t9 = /*#__PURE__*/_jsxs(AriaProgressbar, {
      "aria-label": ariaLabel,
      className: t6,
      isIndeterminate: true,
      ref: ref,
      ...props,
      children: [t7, t8]
    });
    $[33] = ariaLabel;
    $[34] = props;
    $[35] = ref;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  return t9;
};
export const Spinner = /*#__PURE__*/React.forwardRef(BaseSpinner);
//# sourceMappingURL=Spinner.js.map